import { makeStyles } from '@policygenius/mortar';

type Classes = 'card' | 'leftPane' | 'rightPane' | 'rightPaneTitle';
interface Options {
  leftPaneCentered?: boolean;
}

export default makeStyles<Options, Classes>((theme) => {
  const BORDER = `1px solid ${theme.colors.gray500}`;

  return {
    card: {
      border: BORDER,
      background: theme.colors.white,
      margin: [theme.spacing('xlarge'), 0],
    },
    leftPane: {
      padding: [theme.spacing('large'), theme.spacing('medium')],
      textAlign: ({ leftPaneCentered }) => (leftPaneCentered ? 'center' : undefined),
      '& > :not(:last-child)': {
        marginBottom: theme.spacing('medium'),
      },
    },
    rightPane: {
      padding: theme.spacing('large'),
      borderTop: BORDER,
      [`@media (min-width: ${theme.breakpoints.medium}px)`]: {
        borderLeft: BORDER,
        borderTop: 'none',
      },
    },
    rightPaneTitle: {
      marginBottom: theme.spacing('xlarge'),
    },
  };
});
